import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "section content-container" }
const _hoisted_2 = { class: "container is-fluid" }
const _hoisted_3 = { class: "island" }
const _hoisted_4 = { class: "level" }
const _hoisted_5 = { class: "level-right" }
const _hoisted_6 = { class: "level-item" }
const _hoisted_7 = { class: "table is-fullwidth" }

import { HANDLE_SERIOUS_ERROR } from '@/store/app/actionTypes';
import { onBeforeMount, ref } from 'vue';
import { workspacesApi } from '@/workspaces/workspaces';
import { store } from '@/store';
import { UserViewModel } from '@/workspaces/models/userViewModel';
import moment from 'moment';
import InviteUser from '@/features/settings/components/InviteUser.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PlatformAdminListUsers',
  setup(__props) {

const handleSeriousError = (error: string) => store.dispatch(HANDLE_SERIOUS_ERROR, error);
const users = ref<UserViewModel[]>([]);
const isLoading = ref(false);
const showInviteUserModal = ref(false);

onBeforeMount(async () => {
  await loadPlatformAdminUsers();
});

async function loadPlatformAdminUsers() {
  isLoading.value = true;

  try {
    users.value = await workspacesApi.getAllPlatformAdminUsers();
  } catch (err: any) {
    await handleSeriousError(err.message);
  } finally {
    isLoading.value = false;
  }
}

function getStatus(status: number): string {
  if (status === 0) {
    return 'Pending';
  } else if (status === 1) {
    return 'Active';
  }
  return '';
}

function getStatusClass(status: number): string {
  if (status === 0) {
    return 'is-warning';
  } else if (status === 1) {
    return 'is-success';
  }
  return 'is-danger';
}

function formatDate(value: string): string {
  return moment(String(value)).format('DD MMM YYYY');
}

async function handleInviteModalClosed(invited: boolean) {
  showInviteUserModal.value = false;
  if (invited) {
    await loadPlatformAdminUsers();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      (isLoading.value)
        ? (_openBlock(), _createBlock(_component_n_loading_spinner, { key: 0 }))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("nav", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "level-left" }, null, -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, [
                _createVNode(_component_n_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showInviteUserModal.value = true)),
                  variant: "primary"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("span", null, "Invite new Admins", -1)
                  ])),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Name"),
                _createElementVNode("th", null, "Email"),
                _createElementVNode("th", null, "Created"),
                _createElementVNode("th", null, "Status")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: user.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(user.displayName), 1),
                  _createElementVNode("td", null, _toDisplayString(user.userId), 1),
                  _createElementVNode("td", null, _toDisplayString(formatDate(user.createdTimeUtc)), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["tag", getStatusClass(user.status)])
                    }, _toDisplayString(getStatus(user.status)), 3)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ], 512), [
        [_vShow, !isLoading.value]
      ])
    ]),
    (showInviteUserModal.value)
      ? (_openBlock(), _createBlock(InviteUser, {
          key: 0,
          "user-term": "admin",
          "invite-platform-admins": "",
          onClose: handleInviteModalClosed
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})